export const JOB_MODAL_ID = 'job-modal-id';
